module.exports = __webpack_public_path__ + "media/v2/components/PrizesPage/shared/img/3-a1776e67220c8e2851dcbaffb83ba048.png";